import React, { FC, useState, useEffect } from "react";
import Select, { components } from "react-select";
import Option from "./Option";
import { useTranslation } from "react-i18next";

interface MultiSelectProps {
  options: any[];
  defaultValue?: any;
  value?: any;
  allOptionValue: string;
  className: string;
  components: any;
  hideSelectedOptions: boolean;
  isClearable?: boolean;
  closeMenuOnSelect?: boolean;
  onChange: (selected: any[], actionMeta: any) => void;
}

const MultiSelect: FC<MultiSelectProps> = ({
  options,
  defaultValue = [],
  allOptionValue,
  onChange,
}) => {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState<any[]>(defaultValue);
  /**
   * @all
   * if true, 
   * if false, 
   */
  const [all,setAll] = useState(false);
  // const { components, closeMenuOnSelect, isClearable, hideSelectedOptions } = props;
  const MultiValue = (props: any) => {
    let labelToBeDisplayed = `${props.data.label} `;

    if (props.data.value === allOptionValue) {
      labelToBeDisplayed = t('Common.All');
      return (
        <components.MultiValue {...props}  >
          <span>{labelToBeDisplayed}</span>
        </components.MultiValue>
      );
    }

    if (!all) {
      return (
        <components.MultiValue {...props}  >
          <span>{labelToBeDisplayed}</span>
        </components.MultiValue>
      );
    }

    return null;
  };

  const handleSelectChange = (selected: readonly any[], actionMeta: any) => {
    const selectedArray = Array.from(selected)
    let selectAll = false

    const deselectOption: boolean = 
      actionMeta.action === "deselect-option" || actionMeta.action === "remove-value"
    
    if (actionMeta.action === "select-option" && actionMeta.option?.value === allOptionValue) {
      setSelectedOptions(options);
      selectAll = true;
    } else if (deselectOption && 
        (actionMeta.removedValue?.value ?? actionMeta.option?.value) === allOptionValue) {
      setSelectedOptions([]);
    } else if (deselectOption) {
      setSelectedOptions(selectedArray.filter((option) => option.value !== allOptionValue));
    } else if (selectedArray.length === options.length - 1) {
      setSelectedOptions(options);
      selectAll = true;
    } else {
      //not all selected
      setSelectedOptions(selectedArray);
    }
    setAll(selectAll);
  };

  useEffect(() => {
    const actionMeta: any = {
      action: selectedOptions.length === 0 ? "clear" : "deselect-option",
    };
    onChange(selectedOptions, actionMeta);
  }, [selectedOptions, onChange]);

  useEffect(() => {
    const defaultValueWithoutAll = selectedOptions.filter((option:any) => option.value !== allOptionValue);
    const optionsWithoutAll = options.filter((option) => option.value !== allOptionValue);

    // check if all option is selected
    const allOptionSelected = defaultValueWithoutAll.length === optionsWithoutAll.length && defaultValueWithoutAll.length > 0;

    // if all options are selected, select the all option
    if (allOptionSelected && !all) {
        setSelectedOptions(options);
        setAll(true);
    }
  }, [selectedOptions]);

  return (
    <Select
      options={options}
      isMulti
      value={selectedOptions}
      onChange={handleSelectChange}
      components={{Option,MultiValue}}
      hideSelectedOptions={false}
      isClearable={true}
      closeMenuOnSelect={false}
    />
  );
};

export default MultiSelect;